<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @selection-change="handleSelectionChange"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">

                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_STUFF_ADD"
                               @click.stop="handleAdd()"
                    >新增
                    </el-button>
                    <el-button type="warning"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_STUFF_DEL"
                               @click.stop="handleDel('DELETE_OPTION','逻辑删除')">删除
                    </el-button>
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_STUFF_DEL_TRUE"
                               @click.stop="handleDel('DELETE_OPTION','物理删除')">物理删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary"
                               icon="el-icon-check"
                               size="small"
                               plain
                               v-if="permission.JOINS_SALES_CLOUD_STUFF_EDIT"
                               @click.stop="handleEdit(scope.row,scope.index)"
                    >编辑
                    </el-button>
                    <el-button 
                    type="primary" 
                    icon="el-icon-check"
                    size="small"
                    plain
                    @click="staffTurnover(scope)"
                    >
                    人员变动
                    </el-button>
                    
                </template>
                <template slot-scope="scope" slot="departId">
                    <el-tag v-if="scope.row.departName != null">{{scope.row.departName}}</el-tag>
                </template>
                <template slot-scope="scope" slot="departPositionId">
                    <el-tag v-if="scope.row.departPositionName != null">{{scope.row.departPositionName}}</el-tag>
                </template>
                <template slot-scope="scope" slot="departIdForm">
                    <el-select v-model="depart"
                               placeholder="请选择所属部门"
                               required
                               @change="choseDepartPositions"
                               value-key="id"
                        >
                        <el-option v-for="depart in departs" :key="depart.id" :label="depart.name"
                                   :value="depart"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="departPositionIdForm">
                    <el-select v-model="departPosition"
                               placeholder="请选择员工职位"
                               required
                               value-key="id">
                        <el-option v-for="departPosition in departPositions" :key="departPosition.id" :label="departPosition.name"
                                   :value="departPosition"></el-option>
                    </el-select>
                </template>

            </avue-crud>
            <el-dialog title="人员变动" :visible.sync="dialogFormVisible" width="500px" :close-on-click-modal="false">
                        <el-form :model="form" >
                            <el-form-item label="在职状态">
                                <!-- <el-select v-model="currentStatus" :disabled="false">
                                    <el-option :key="currentStatus.id" :label="currentStatus.name"
                                                :value="currentStatus.name" >
                                    </el-option>
                                </el-select> -->
                                <el-input v-model="currentStatus" :disabled="true">

                                </el-input>
                            </el-form-item>
                            <el-form-item label="变动">
                                <el-select v-model="changeStatus">
                                    <el-option v-for="changeStatus in jobStatus" :key="changeStatus.id"
                                                :value="changeStatus.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="变动时间">
                                 <el-date-picker
                                    v-model="time"
                                    type="datetime"
                                    placeholder="选择日期"
                                    value-format="timestamp">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="离职原因"
                            prop="dismissReason"
                            >
                                <el-input
                                type="textarea"
                                placeholder="离职请填写原因,其他不填"
                                :rows="8"
                                v-model="dismissReason">

                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="changeStuff()">确 定</el-button>
                        </div>
            </el-dialog>            
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {stuffTableOption} from "@/const/salesCloud/stuffOption";
    import {findStuff, addStuff, editStuff, delStuff, chaStuff} from "@/api/salesCloud/stuff"
    import { findDepartmentAll } from "@/api/salesCloud/department"
    import { findPositionByDepart } from "@/api/salesCloud/position"
    import {findByLabel, parseParam} from "@/util/util"
    import {DIC} from "@/const/dic"

    export default {
        name: "stuff",
        components: {
        },
        data() {
            return {
                tableOption: stuffTableOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                dialogFormVisible: false,
                tabelObj: {},
                time:'',
                stuffIds:'',
                dismissReason:'',
                currentStatus:[],
                changeStatus:[],
                jobStatus: [],
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                form: {  //人员变动
                delivery: false,
                reason:'',
                type: [],
                dismissReason:'',
                resource: '',
                desc: ''
                },
                departs: [],
                depart: {},
                departPositions: [],
                departPosition:{}
            };
        },
        created() {
            // 查询部门
            findDepartmentAll().then((res) => {
                let data = JSON.parse(res.data)
                this.departs = data
            })

            this.handleList();
        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            staffTurnover (scope) {
                console.log(this)
                this.changeStatus = ''
                this.stuffIds = scope.row.id
                this.currentStatus = scope.row.jobStatus =='ON_JOB'?'在职':(scope.row.jobStatus =='DISMISSION'?'离职':'实习期')
                // this.changeStatus = scope.row.jobStatus =='ON_JOB'?'离职':(scope.row.jobStatus =='INTERNSHIP'?'转正':'离职')
                if(this.currentStatus == '离职'){
                    this.dismissReason = scope.row.dismissReason
                    // this.time = scope.row.quitTime //上一次离职时间
                    this.time = ''
                }else{
                    this.dismissReason = ''
                    // this.time = scope.row.regularTime //上一次转正时间
                    this.time = ''
                }
                if(scope.row.jobStatus == 'INTERNSHIP')
                {//变动状态
                    this.jobStatus = [{"name":"转正","value":"ON_JOB"},{"name":"离职","value":"DISMISSION"}]
                }else{
                    this.jobStatus = [{"name":"离职","value":"DISMISSION"}]
                }
                console.log(scope)
                this.dialogFormVisible  = true
                console.log(this.dialogFormVisible)
            },
                //员工状态改变确定按钮
            changeStuff(){
                console.log(this)
                /**
                 *多选时传参
                **/
                let stuffIds = new Array();
                for (let row of this.$refs.crud.tableSelect) {
                    stuffIds.push(row.id)
                    // console.log(row)
                }
                stuffIds.push(this.stuffIds)
                const removeDuplicateItems = arr => [...new Set(arr)]//去重
                stuffIds = removeDuplicateItems(stuffIds)
                let selectStuffIds = stuffIds.join(",")
                // console.log(stuffIds.length)
                // console.log(selectStuffIds)
                // console.log(this.changeStatus)
                let jobStatus = this.changeStatus == '离职'?'DISMISSION':(this.changeStatus == '转正' ?'ON_JOB':'')
                this.dismissReason = this.dismissReason.replace(/(^\s+)|(\s+$)/g,"")
                // console.log(this.dismissReason)
                // console.log(jobStatus)
                let params = {
                    time:this.time,
                    jobStatus,
                    dismissReason:this.dismissReason
                }
                params = parseParam(params)
                console.log(params)
                if(this.changeStatus == '离职' && this.dismissReason == null){
                    this.$message({
                            showClose: false,
                            message: "请填写离职理由",
                            type: "error"
                        });
                }else if(jobStatus == '') {
                    console.log('请选择变动类型')
                     this.$message({
                            showClose: false,
                            message: "请选择变动类型",
                            type: "error"
                        });
                }else if(this.time == null) {
                     this.$message({
                            showClose: false,
                            message: "请选择变动时间",
                            type: "error"
                        });
                }
                else{
                    chaStuff(selectStuffIds,params).then((res) => {
                    console.log(res)
                    if (res.code == '200') {
                        this.$message({
                            showClose: true,
                            message: "更改成功",
                            type: "success"
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message:'请填写离职理由.'+ res.message,
                            type: "error"
                        })
                    }
                })
                }
                
                if(this.changeStatus == '转正' && this.time){
                    this.dialogFormVisible = false
                }
                else if(this.changeStatus == '离职' && this.dismissReason && this.time){
                    this.dialogFormVisible = false
                }
            },
            choseDepartPositions(){
                findPositionByDepart(this.depart.id).then((res) => {
                    let data = JSON.parse(res.data)
                    this.departPositions = data
                })
            },
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findStuff(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findStuff(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findStuff(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findStuff(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
           
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                if(null != row.departId){
                    this.depart = {
                        id : row.departId
                    }
                    this.departPosition = {
                        id: row.departPositionId
                    }
                    this.choseDepartPositions()
                }
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findStuff(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    console.log(this.tableData)
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 当前选中的数据
             * @param val 选中的值
             *
             **/
            handleSelectionChange () {
                // console.log(val);
                // this.tableRow = val;
                // this.$notify({
                //     showClose: true,
                //     message: JSON.stringify(val),
                //     type: 'success',
                // });
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                row.departId = this.depart.id
                row.departPositionId = this.departPosition.id
                console.log(row,done)
                console.log('新增')
                addStuff(row).then(response => {
                    if (response.code == '200') {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success"
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {
                if (this.$refs.crud.tableSelect.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择要操作的数据",
                        type: "error"
                    })
                    return
                }

                this.$confirm(`是否确认删除?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let ids = new Array();
                        for (let row of this.$refs.crud.tableSelect) {
                            ids.push(row.id)
                        }

                        delStuff(findByLabel(DIC.DELETE_OPTION, label), ids).then(response => {
                            if (response.code == '200') {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error"
                                })
                            }

                        }).catch(error => {
                            this.loading = false
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error"
                            })
                        })
                    })
                    .catch(() => {
                    });

            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {
                row.departId = this.depart.id
                row.departPositionId = this.departPosition.id
                editStuff(row).then(response => {
                    if (response.code == '200') {
                        this.$message({
                            showClose: true,
                            message: "修改成功",
                            type: "success"
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error"
                        })
                    }

                }).catch(error => {
                    this.loading = false
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error"
                    })
                })
                done();
            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
